import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { UserModel } from '../../models';
import { modalSmall, modalLarge } from '../../shared/modules/dialogOptions'
import { AccountService, CommonService, DepartmentService, UserService } from '../../services';

@Component({
    selector: 'app-users-edit',
    templateUrl: './users-edit.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class UsersEditComponent extends BaseComponent implements OnInit {
    @Output() userListView = new EventEmitter();
    @ViewChild('userPassword') passwordEl: ElementRef;
    public model: any;
    public role: any;
    public accountId: any;
    public accountsList: any;
    public userRolesList: any;
    public hideAccountSelect: boolean = true;
    public departmentList: any = [];
    public showSpinner: boolean = false;
    public accessMode: any;
    IsUser: boolean = false;
    public isNew: boolean = false;
    hideCancel: boolean = true;
    userConfirm: string;
    dataToDelete: any;
    isUserModified = false;
    constructor(
        private modalService: NgbModal,
        private accountService: AccountService,
        private commonService: CommonService,
        private departmentService: DepartmentService,
        private userService: UserService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private router: Router,
        public activeModal: NgbActiveModal,
        private location: Location) {
        super(router)
    }
    public id: any;
    public res: any;
    public ngOnInit() {



        this.model = new UserModel();
        const accountId = super.currentLoggedUser().accountId;
        this.model.AccountId = accountId;
        this.accountId = accountId;
        if (this.id) {
            this.loadData(this.id);
            this.accessMode = 'direct';
        }
        if (this.res == 1) {
            this.isNew = true;
            setTimeout(() => {
                this.passwordEl.nativeElement.focus();
            }, 1000);

        }

        // this.route.params.subscribe((params) => {
        //     if (params) {
        //         const accountId = super.currentLoggedUser().accountId;
        //         this.model.AccountId = accountId;
        //         this.accountId = accountId;
        //         const id = params['id'];
        //         const res = params['res'];
        //         if(id){
        //             this.loadData(id);
        //             this.accessMode = 'direct';
        //         }
        //         if(res == 1)
        //         {
        //             this.isNew = true;
        //             setTimeout(() => {
        //                 this.passwordEl.nativeElement.focus();
        //             }, 1000);

        //         }
        //     }
        // });
        this.setDefaults();
        this.passwordEl.nativeElement.focus();
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser.role === 'admin') {
            this.hideCancel = false;
        }
        this.role = currentUser.role;
    }

    public setDefaults(userId?: number) {
        this.loadUserRoles();
        if (userId) {
            this.loadData(userId);
            this.accessMode = 'embed';
        }
        this.loadDepartments(this.accountId);
        this.model.AccountId = this.accountId;
    }

    public loadData(id: number) {
        this.showSpinner = true;
        this.userService.getUser(id)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.Data) {
                    this.model = response.Data;
                    this.model.PasswordReType = '';
                }
            });
    }

    public isSendCreds(evt) {
        if (evt.target.checked) {
            this.model.IsSendCreds = true;
        } else {
            this.model.IsSendCreds = false;
        }
    }

    public saveChanges() {
        this.showSpinner = true;
        this.model.IsUpdate = true;
        this.isUserModified = true;

        this.userService.updateUser(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.toastr.error(response.Message, "Error");
                }
                else {
                    this.ngOnInit();
                    this.closeUserCreateView();
                }
            });
    }
    @ViewChild('resendEmail') resendEmail: TemplateRef<any>;
    public loadAccountData(): void {
        let filter = '';
        this.accountService.getAccountsList(1, 100, filter)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.accountsList = response.Data;
            });
    }
    tosendData: any;
    modalReference: NgbModalRef;
    public openType(content: string): void {

        this.tosendData = this.model;
        this.modalReference = this.modalService.open(content, modalSmall);

    }
    public resendCreateUserConfirmation(model: UserModel) {
        this.tosendData = model;
        model.Resending = true;
        this.userService.resendCreateUserConfirmation(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {
                if (response.Success) {
                    this.toastr.success(response.Message, "Create User Confirmation Email Sent.");
                }

                model.Resending = false;
                this.activeModal.close();
            });

    }
    public deleteUsers(model: any) {
        this.userService.deleteUser(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {

                if (response.Success) {
                    this.toastr.success(response.Message);
                } else {
                    this.toastr.error(response.Message);
                }

                this.activeModal.close();
                //this.DeleteObjectEventData.emit();
            });
    }

    public openDelete(title: string) {
        this.userConfirm = "";
        this.dataToDelete = this.model;
        this.modalService.open(title, modalSmall);
    }

    public loadUserRoles(): void {
        //getAllUserRoles
        this.commonService.getAllUserRoles()
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.userRolesList = response.Data;
            });
    }

    public isPasswordMatched() {
        return this.model.Password ? this.model.PasswordReType === this.model.Password : true;
    }

    public loadDepartments(accountId) {
        this.departmentService.getDepartmentByAccountId(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.departmentList = response.Data;
            });
    }

    public emailAddressChange() {

        //this.model.UserName = this.model.EmailAddress;
    }

    public closeUserCreateView() {
        const id = this.accountId;
        this.model = new UserModel();
        if (this.userListView.observers.length > 0) {
            this.userListView.emit();
        }
        else {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser.role === 'admin' || currentUser.isAdministrationAdmin) {
                this.router.navigate([`accounts/${id}/edit/users`]);
            }

        }

    }
}



// WEBPACK FOOTER //
// ./src/app/components/users/users-edit.component.ts